import { render } from "./ace-loading.vue?vue&type=template&id=9a4bd0fa&scoped=true"
import script from "./ace-loading.vue?vue&type=script&lang=js"
export * from "./ace-loading.vue?vue&type=script&lang=js"

import "./ace-loading.vue?vue&type=style&index=0&id=9a4bd0fa&scoped=true&lang=css"

import exportComponent from "C:\\workspace\\repository\\sprfidspring\\src\\main\\vue-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a4bd0fa"]])

export default __exports__